import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { getUserInfo, getUserLocationFromAPI } from "../../core/APIService/apiService"
import BannerWrapper from "./TMHBannerWrapper"
import BannerNavBar from "./TMHBannerNavBar"
import LogoImg from "./logo.png"
import SpinnerImg from "./spinner.png"
import useAuth from "../../core/Authentication/useAuth"
import ReactGA from 'react-ga4'
import { ReactComponent as Person } from "./person.svg"
import Popup from 'reactjs-popup'
import "./TMHBannerStyles.scss";

function TMHBanner({ children, classOption = "wrapper-banner", isLogged = true, styleId = 1, navClass = "navbar-banner", showLoginInfo = true, useSpinner = false }) {
    const navigate = useNavigate()
    const location = useLocation()
    const auth = useAuth()

    const style2 = {
        marginTop: "-5px"
    }

    const styleLogin = {
        marginTop: "20px"
    }

    function handleLoginButton() {
        if (location.pathname !== "/login") {
            navigate("/login")
            ReactGA.send("pageview")
        }
    }

    function handleLogoutButton() {
        auth.logout()
        navigate("/")
    }

    const [openPopup, setOpenPopup] = useState(false)
    useEffect(() => {
        const initData = async () => {
            var user_id = -1
            if (auth.user?.user_id) user_id = auth.user?.user_id
            var locationData = await getUserLocationFromAPI(user_id)
            if (locationData.toUpperCase() === "US") {
                if (auth.isLogged() && isLogged) {
                    const data = await getUserInfo(auth.user.token)

                    if (data) {
                        if (data.status === 401) {
                            auth.logout()
                        }
                    }
                }
            } else {
                setOpenPopup(true)
            }
        }

        initData()
    }, [auth, isLogged])

    return (
        <BannerWrapper className={classOption}>
            {children}
            {showLoginInfo && <BannerNavBar className={navClass}>
                <div>
                    <a href={auth.isLogged() ? "/tmh/#/profile" : "https://themoviehouse.tv/"}>
                        <img className="logo" src={LogoImg} style={styleId === 1 ? {} : style2} alt="Movie House logo" />
                    </a>
                </div>
                {(auth.isLogged() && isLogged) ? (
                    <div className="user-info">
                        {useSpinner && <a href="/tmh/#/request-coupon" target="_blank"> <img className="spinner" src={SpinnerImg} alt="spinner" /></a>}
                        <a href="/tmh/#/profile" className="user-name">
                            <Person fill="white" width={24} />
                            <p>{auth.user?.pin}</p>
                        </a>
                        <button className="logout-btn" onClick={handleLogoutButton}>Log Out</button>
                    </div>
                ) : (
                    <button className="login-button" style={styleId === 1 ? {} : styleLogin} onClick={handleLoginButton}>
                        <div className="login-text">Log In</div>
                    </button>
                )}
            </BannerNavBar>}
            <Popup
                onClose={() => {
                    window.open("about:blank", "_self");
                    window.close();
                }}
                modal
                open={openPopup}
                overlayStyle={{
                    "backgroundColor": "#000000B2"
                }}
            >
                <div className="modal-nonus">
                    <div className="content">
                        <div className="title"><b>Apologies....</b></div>
                        <div className="description">
                            We currently only support customers inside the USA. We continue to expand our services so please check back in the future
                        </div>

                        <button className="close-button" onClick={() => {
                            window.open("about:blank", "_self");
                            window.close();

                        }}>Close window</button>
                    </div>
                </div>
            </Popup>
        </BannerWrapper>
    )
}

export default TMHBanner
